import { useCallback } from "react";
import { useTenant } from "../../../context/TenantContext";
import useResource from "../../../hooks/useResource";
import { assetUrl } from "../../../lib/assets";
import { readPublishedWebsite } from "../services/publicWebsite";

/** Shared published assets for merchant chrome, without changing document metadata. */
export default function useWebsiteBranding() {
  const { merchant, branding = {} } = useTenant();
  const tenantKey = merchant?.id || merchant?.code_url || merchant?.url_code || merchant?.code || "";
  const merchantCode = merchant?.code_url || merchant?.url_code || undefined;
  const load = useCallback(signal => tenantKey ? readPublishedWebsite(signal) : Promise.resolve(null), [tenantKey]);
  const resource = useResource(load);
  const resolve = value => assetUrl(value, { merchantCode });
  return {
    logoUrl: resolve(resource.data?.logo_url) || resolve(branding.website_logo_url) || resolve(branding.logo_url),
    heroUrl: resolve(resource.data?.hero?.background_url),
    faviconUrl: resolve(resource.data?.favicon_url) || resolve(branding.favicon_url),
    merchantCode, loading: resource.loading, error: resource.error, reload: resource.reload,
  };
}
